<template>
  <div
    class="group relative flex min-h-20 flex-col rounded-md border border-primary px-2.5 py-1.5 text-sm"
    :style="{ 'border-color': product.color }"
    @contextmenu.prevent
  >
    <div
      class="absolute inset-0 z-[-1] opacity-10 transition-opacity group-active:opacity-30"
      :style="{ 'background-color': product.color }"
    />

    <p
      class="mb-1 flex-1 text-left font-semibold leading-tight text-background-fg/80"
    >
      {{ product.name }}
    </p>
    <div class="mb-1 flex flex-1">
      <div
        v-for="tag in tags"
        :key="tag.id"
        class="relative h-2 max-w-[0.6875rem] flex-1 last:min-w-2.5"
      >
        <div
          class="absolute left-0 top-0 size-2.5 rounded-full bg-background-fg/30"
          :style="{
            backgroundColor:
              PRODUCT_TAG_COLOR_MAP[tag.color].color,
          }"
        />
      </div>
    </div>
    <p
      class="text-left text-xs leading-tight text-background-fg/60"
      >{{ priceString }}</p
    >
    <div
      v-if="productInCartQuantity"
      class="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-xs text-primary-fg"
    >
      <span class="line-clamp-1 text-xs font-semibold">
        {{ productInCartQuantity }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  type ProductTag,
  useProductTags,
} from "@/services/product-tags/listProductTags"
import { PRODUCT_TAG_COLOR_MAP } from "@/services/product-tags/productTagColors"
import type { Product } from "@/services/sharedTypes/products"

const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  product: Product
}>()

const { getProductCount } = useCurrentOrder()
const { merchantCurrencySymbol } = useCurrency()

const priceString = computed(() =>
  props.product.hasVariablePrice
    ? `${merchantCurrencySymbol.value} variable`
    : formatToMerchantCurrencyString(props.product.price)
)

const productInCartQuantity = computed(() =>
  getProductCount(props.product.id)
)

const { data: productTags } = useProductTags()
const tags = computed(() =>
  productTags.value
    ? props.product.tagIds.slice(0, 10).reduce((agg, v) => {
        const tag = productTags.value.find(
          (_tag) => _tag.id === v && !_tag.isHidden
        )

        return tag ? [...agg, tag] : agg
      }, [] as ProductTag[])
    : []
)
</script>
